import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { CheckCircle2, XCircle } from "lucide-react";
import { userApi } from "../../lib/api";
import Seo from "../../components/Seo";

export default function VerifyEmail() {
  const [sp] = useSearchParams(); const token = sp.get("token");
  const [status, setStatus] = useState("checking");
  useEffect(() => {
    if (!token) { setStatus("failed"); return; }
    userApi.post("/auth/verify-email", { token }).then(() => setStatus("ok")).catch(() => setStatus("failed"));
  }, [token]);
  const ok = status === "ok";
  return (
    <div className="min-h-screen flex items-center justify-center bg-brand-cream px-6 py-28">
      <Seo title="E-posta Doğrulama" />
      <div className="w-full max-w-md bg-brand-offwhite border border-brand-gold-light/40 rounded-sm p-10 text-center">
        {status === "checking" ? <p className="text-brand-text/60">Doğrulanıyor…</p> : (
          <>
            {ok ? <CheckCircle2 className="mx-auto text-brand-green" size={52} /> : <XCircle className="mx-auto text-red-600" size={52} />}
            <h1 className="font-serif text-2xl text-brand-green mt-4">{ok ? "E-postan doğrulandı" : "Doğrulama başarısız"}</h1>
            <p className="text-brand-text/60 mt-2">{ok ? "Teşekkürler! Artık tüm özelliklere erişebilirsin." : "Bağlantı geçersiz veya süresi dolmuş olabilir."}</p>
            <Link to="/hesabim" className="inline-block mt-6 bg-brand-gold text-brand-offwhite px-6 py-3 rounded-sm font-semibold">Hesabıma Git</Link>
          </>
        )}
      </div>
    </div>
  );
}
